import React, { useState, useEffect } from 'react';
import MainLayout from '../../layouts/MainLayout';
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import './index.scss';
import { formatValueByMetric, replaceAllCharacter } from '../../utils/CommonUtil';
import { mediaData } from '../../store/widget/reducer';
import { publisherData } from '../../store/publisher/reducer';
import * as LocalStorageUtil from '../../utils/LocalStorageUtil';
import { actionCauseTypes, buildTemplateRuleSettingString, buildDateString, buildOptionsSlider, alertDataLevelOptions } from '../../utils/AlertUtil';
import * as Constant from "../../utils/Constant";
var AlertCardDetailsPage = function (props) {
    var t = useTranslation().t;
    var history = useHistory();
    var alertCache = LocalStorageUtil.getItem(LocalStorageUtil.ALERT_KEY);
    var itemAlert = alertCache ? JSON.parse(alertCache) : null;
    var _a = useState(""), currentRule = _a[0], setCurrentRule = _a[1];
    var _b = useState([]), rowItems = _b[0], setRowItems = _b[1];
    var _c = useState([]), columns = _c[0], setColumns = _c[1];
    var _d = React.useState(0), page = _d[0], setPage = _d[1];
    var _e = React.useState(10), rowsPerPage = _e[0], setRowsPerPage = _e[1];
    var _f = useState(false), isEnableRuleSetting = _f[0], setEnableRuleSetting = _f[1];
    var _g = useState(null), dataAlert = _g[0], setDataAlert = _g[1];
    useEffect(function () {
        document.title = t("page.alert_details") + Constant.APP_NAME;
        return (function () {
            setEnableRuleSetting(false);
        });
    }, []);
    useEffect(function () {
        handleDetailAlert();
    }, [alertCache]);
    var handleDetailAlert = function () {
        var itemAlertData = itemAlert;
        if (itemAlertData && itemAlertData.data && props.match && props.match.params
            && props.match.params.alertId == itemAlertData.data.id) {
            var detailData = itemAlertData.data.messageDetail ? itemAlertData.data.messageDetail : null;
            if (detailData) {
                onBuildCurrentRule(detailData);
                onBuildTableAlertDetail(detailData);
            }
        }
        else {
            history.push("/dashboard");
        }
    };
    var prepareActionTypeList = function (formData, sliderData1, sliderData2, duration, type, rule) {
        var actionTypeCauseData = _.cloneDeep(actionCauseTypes);
        if (actionTypeCauseData && actionTypeCauseData.length) {
            // var foundType2 = actionTypeCauseData.findIndex((actionType: any) => {
            //     return actionType.value == 2;
            // });
            // if (foundType2 >= 0) actionTypeCauseData.splice(foundType2, 1); 
            actionTypeCauseData = [];
        }
        else {
            actionTypeCauseData = _.cloneDeep(actionCauseTypes);
        }
        if (formData.customDurationTypeRange == "BEFORE_YESTERDAY" || formData.checkingDurationTypeRange == "YESTERDAY") {
            if (formData.customDurationTypeRange == "BEFORE_YESTERDAY" && formData.checkingDurationTypeRange == "YESTERDAY") {
                var fromMetricTranslate = t("alert.from_metric");
                var compare2MetricTranslate = t("alert.compare_2_metric");
                var compareMetricTranslate = t("alert.compare_a_metric");
                if (fromMetricTranslate.indexOf("{period1}")) {
                    fromMetricTranslate = replaceAllCharacter(fromMetricTranslate, "{period1}", "yesterday");
                }
                if (compare2MetricTranslate.indexOf("{period1}")) {
                    compare2MetricTranslate = replaceAllCharacter(compare2MetricTranslate, "{period1}", "yesterday");
                }
                if (compareMetricTranslate) {
                    compareMetricTranslate = replaceAllCharacter(compareMetricTranslate, "{period1}", "yesterday");
                    compareMetricTranslate = replaceAllCharacter(compareMetricTranslate, "{period2}", "before yesterday");
                }
                actionTypeCauseData = [
                    {
                        name: fromMetricTranslate,
                        value: 1,
                        templateStr: "Yesterday, {metric} {operator} {value}"
                    },
                    {
                        name: compareMetricTranslate,
                        value: 2,
                        templateStr: "{metric} in yesterday is {operator} {value} than {metric} in before yesterday"
                    },
                    {
                        name: compare2MetricTranslate,
                        value: 3,
                        templateStr: "Yesterday, the ratio of {metric} {operator} {value}"
                    }
                ];
            }
            else {
                if (formData.customDurationTypeRange == "BEFORE_YESTERDAY") {
                    var startDate = "";
                    var endDate = "";
                    if (formData.checkingDurationTypeRange == "CUSTOM_PERIOD") {
                        var foundSlider1StartDate = (sliderData1.options || []).find(function (item) { return item.value == sliderData1.value[0]; });
                        var foundSlider1EndDate = (sliderData1.options || []).find(function (item) { return item.value == sliderData1.value[1]; });
                        startDate = foundSlider1StartDate ? foundSlider1StartDate.legend : "";
                        endDate = foundSlider1EndDate ? foundSlider1EndDate.legend : "";
                    }
                    else {
                        if (duration) {
                            startDate = duration["startDate"] ? duration["startDate"] : "";
                            endDate = duration["endDate"] ? duration["endDate"] : "";
                        }
                        else {
                            var durationChecking = buildDateString(formData.checkingDurationTypeRange, true);
                            startDate = durationChecking["startDate"] ? durationChecking["startDate"] : "";
                            endDate = durationChecking["endDate"] ? durationChecking["endDate"] : "";
                        }
                    }
                    var fromMetricTranslate = t("alert.from_metric");
                    var compare2MetricTranslate = t("alert.compare_2_metric");
                    var compareMetricTranslate = t("alert.compare_a_metric");
                    if (fromMetricTranslate.indexOf("{period1}")) {
                        fromMetricTranslate = replaceAllCharacter(fromMetricTranslate, "{period1}", "" + startDate + " - " + endDate);
                    }
                    if (compare2MetricTranslate.indexOf("{period1}")) {
                        compare2MetricTranslate = replaceAllCharacter(compare2MetricTranslate, "{period1}", "" + startDate + " - " + endDate);
                    }
                    if (compareMetricTranslate) {
                        compareMetricTranslate = replaceAllCharacter(compareMetricTranslate, "{period1}", "" + startDate + " - " + endDate);
                        compareMetricTranslate = replaceAllCharacter(compareMetricTranslate, "{period2}", "before yesterday");
                    }
                    actionTypeCauseData = [
                        {
                            name: fromMetricTranslate,
                            value: 1,
                            templateStr: "" + startDate + " - " + endDate + ", {metric} {operator} {value}"
                        },
                        {
                            name: compareMetricTranslate,
                            value: 2,
                            templateStr: "{metric} in " + startDate + " - " + endDate + " is {operator} {value} than {metric} in before yesterday"
                        },
                        {
                            name: compare2MetricTranslate,
                            value: 3,
                            templateStr: "" + startDate + " - " + endDate + ", the ratio of {metric} {operator} {value}"
                        }
                    ];
                }
                else {
                    var startDate2 = "";
                    var endDate2 = "";
                    if (formData.customDurationTypeRange == "CUSTOM_PERIOD") {
                        var foundSlider2StartDate = (sliderData2.options || []).find(function (item) { return item.value == sliderData2.value[0]; });
                        var foundSlider2EndDate = (sliderData2.options || []).find(function (item) { return item.value == sliderData2.value[1]; });
                        startDate2 = foundSlider2StartDate ? foundSlider2StartDate.legend : "";
                        endDate2 = foundSlider2EndDate ? foundSlider2EndDate.legend : "";
                    }
                    else {
                        if (duration) {
                            startDate2 = duration["startDate"] ? duration["startDate"] : "";
                            endDate2 = duration["endDate"] ? duration["endDate"] : "";
                        }
                        else {
                            var durationCompare = buildDateString(formData.customDurationTypeRange, true);
                            startDate2 = durationCompare["startDate"] ? durationCompare["startDate"] : "";
                            endDate2 = durationCompare["endDate"] ? durationCompare["endDate"] : "";
                        }
                    }
                    var fromMetricTranslate = t("alert.from_metric");
                    var compare2MetricTranslate = t("alert.compare_2_metric");
                    var compareMetricTranslate = t("alert.compare_a_metric");
                    if (fromMetricTranslate.indexOf("{period1}")) {
                        fromMetricTranslate = replaceAllCharacter(fromMetricTranslate, "{period1}", "yesterday");
                    }
                    if (compare2MetricTranslate.indexOf("{period1}")) {
                        compare2MetricTranslate = replaceAllCharacter(compare2MetricTranslate, "{period1}", "yesterday");
                    }
                    if (compareMetricTranslate) {
                        compareMetricTranslate = replaceAllCharacter(compareMetricTranslate, "{period1}", "yesterday");
                        compareMetricTranslate = replaceAllCharacter(compareMetricTranslate, "{period2}", "" + startDate2 + " - " + endDate2);
                    }
                    actionTypeCauseData = [
                        {
                            name: fromMetricTranslate,
                            value: 1,
                            templateStr: "Yesterday, {metric} {operator} {value}"
                        },
                        {
                            name: compareMetricTranslate,
                            value: 2,
                            templateStr: "{metric} in yesterday is {operator} {value} than {metric} in " + startDate2 + " - " + endDate2
                        },
                        {
                            name: compare2MetricTranslate,
                            value: 3,
                            templateStr: "Yesterday, the ratio of {metric} {operator} {value}"
                        }
                    ];
                }
            }
        }
        else {
            var startDate = "";
            var endDate = "";
            var startDate2 = "";
            var endDate2 = "";
            if (formData.checkingDurationTypeRange == "CUSTOM_PERIOD") {
                var foundSlider1StartDate = (sliderData1.options || []).find(function (item) { return item.value == sliderData1.value[0]; });
                var foundSlider1EndDate = (sliderData1.options || []).find(function (item) { return item.value == sliderData1.value[1]; });
                startDate = foundSlider1StartDate ? foundSlider1StartDate.legend : "";
                endDate = foundSlider1EndDate ? foundSlider1EndDate.legend : "";
            }
            else {
                var durationChecking = type == "CHECKING" ? duration : buildDateString(formData.checkingDurationTypeRange, true);
                startDate = durationChecking["startDate"] ? durationChecking["startDate"] : "";
                endDate = durationChecking["endDate"] ? durationChecking["endDate"] : "";
            }
            if (formData.customDurationTypeRange == "CUSTOM_PERIOD") {
                var foundSlider2StartDate = (sliderData2.options || []).find(function (item) { return item.value == sliderData2.value[0]; });
                var foundSlider2EndDate = (sliderData2.options || []).find(function (item) { return item.value == sliderData2.value[1]; });
                startDate2 = foundSlider2StartDate ? foundSlider2StartDate.legend : "";
                endDate2 = foundSlider2EndDate ? foundSlider2EndDate.legend : "";
            }
            else {
                var durationChecking2 = type == "COMPARE" ? duration : buildDateString(formData.customDurationTypeRange, true);
                startDate2 = durationChecking2["startDate"] ? durationChecking2["startDate"] : "";
                endDate2 = durationChecking2["endDate"] ? durationChecking2["endDate"] : "";
            }
            var fromMetricTranslate = t("alert.from_metric");
            var compare2MetricTranslate = t("alert.compare_2_metric");
            var compareMetricTranslate = t("alert.compare_a_metric");
            if (fromMetricTranslate.indexOf("{period1}")) {
                fromMetricTranslate = replaceAllCharacter(fromMetricTranslate, "{period1}", "" + startDate + " - " + endDate);
            }
            if (compare2MetricTranslate.indexOf("{period1}")) {
                compare2MetricTranslate = replaceAllCharacter(compare2MetricTranslate, "{period1}", "" + startDate + " - " + endDate);
            }
            if (compareMetricTranslate) {
                compareMetricTranslate = replaceAllCharacter(compareMetricTranslate, "{period1}", "" + startDate + " - " + endDate);
                compareMetricTranslate = replaceAllCharacter(compareMetricTranslate, "{period2}", "" + startDate2 + " - " + endDate2);
            }
            actionTypeCauseData = [
                {
                    name: fromMetricTranslate,
                    value: 1,
                    templateStr: "" + startDate + " - " + endDate + ", {metric} {operator} {value}"
                },
                {
                    name: compareMetricTranslate,
                    value: 2,
                    templateStr: "{metric} in " + startDate + " - " + endDate + " is {operator} {value} than {metric} in " + startDate2 + " - " + endDate2
                },
                {
                    name: compare2MetricTranslate,
                    value: 3,
                    templateStr: "" + startDate + " - " + endDate + ", the ratio of {metric} {operator} {value}"
                }
            ];
        }
        var rule = rule ? rule : {
            ruleSetting: null
        };
        var ruleString = "";
        var detailSetting = buildTemplateRuleSettingString(rule.ruleSetting, actionTypeCauseData, 0);
        if (formData.enableSettingRule) {
            ruleString = detailSetting;
        }
        else {
            ruleString = formData && formData.ruleDescription ? formData.ruleDescription : "";
        }
        setCurrentRule(ruleString);
    };
    var buildPeriodData = function (data) {
        var rule = {
            ruleSetting: null
        };
        var dataRule = _.cloneDeep(data.ruleSetting);
        delete (dataRule.standardAlertSettingId);
        rule.ruleSetting = dataRule;
        var formatDate = "YYYY/MM/DD";
        var foundDateSlider = function (dateStr, dates) {
            var dateAfter1Date = moment().subtract(1, 'days');
            var yesterdateString = dateAfter1Date.format(formatDate);
            if (dateStr == yesterdateString)
                dateStr = "Yesterday";
            var foundDateMin = dates.find(function (date) {
                return date.legend == dateStr;
            });
            return foundDateMin;
        };
        var sliderData1 = {
            slider1Length: "7d",
            options: [],
            value: [],
            maxLength: 7
        };
        var sliderData2 = {
            slider1Length: "7d",
            options: [],
            value: [],
            maxLength: 7
        };
        //build period 1
        var formatDate = "YYYY/MM/DD";
        if (data.checkingDurationTypeRange != "YESTERDAY") {
            if (data.checkingDurationTypeRange == "CUSTOM_PERIOD") {
                sliderData1.slider1Length = data.checkingDurationSlideLength;
                sliderData1.options = buildOptionsSlider(data.checkingDurationSlideLength);
                if (sliderData1.options && sliderData1.options.length) {
                    var minValueDate = moment(data.checkingDurationFromDate, "YYYYMMDD").format(formatDate);
                    var maxValueDate = moment(data.checkingDurationToDate, "YYYYMMDD").format(formatDate);
                    var minDate = foundDateSlider(minValueDate, sliderData1.options);
                    var maxDate = foundDateSlider(maxValueDate, sliderData1.options);
                    sliderData1.value = [
                        minDate ? minDate.value : sliderData1.options[0].value,
                        maxDate ? maxDate.value : sliderData1.options[sliderData1.options.length - 1].value
                    ];
                    sliderData1.maxLength = sliderData1.options.length - 1;
                }
                prepareActionTypeList(data, sliderData1, sliderData2, null, "CHECKING", rule);
            }
            else {
                var dateRange = buildDateString(data.checkingDurationTypeRange, true);
                prepareActionTypeList(data, sliderData1, sliderData2, dateRange, "CHECKING", rule);
            }
        }
        else {
            prepareActionTypeList(data, sliderData1, sliderData2, null, "CHECKING", rule);
        }
        //build period 2
        if (data.customDurationTypeRange != "BEFORE_YESTERDAY") {
            if (data.customDurationTypeRange == "CUSTOM_PERIOD") {
                sliderData2.slider2Length = data.customDurationSlideLength;
                sliderData2.options = buildOptionsSlider(data.customDurationSlideLength);
                if (sliderData2.options && sliderData2.options.length) {
                    var minValueDate2 = moment(data.customDurationFromDate, "YYYYMMDD").format(formatDate);
                    var maxValueDate2 = moment(data.customDurationToDate, "YYYYMMDD").format(formatDate);
                    var minDate2 = foundDateSlider(minValueDate2, sliderData2.options);
                    var maxDate2 = foundDateSlider(maxValueDate2, sliderData2.options);
                    sliderData2.value = [
                        minDate2 ? minDate2.value : sliderData2.options[0].value,
                        maxDate2 ? maxDate2.value : sliderData2.options[sliderData2.options.length - 1].value
                    ];
                    sliderData2.maxLength = sliderData2.options.length - 1;
                }
                prepareActionTypeList(data, sliderData1, sliderData2, null, "COMPARE", rule);
            }
            else {
                var dateRange2 = buildDateString(data.customDurationTypeRange, true);
                prepareActionTypeList(data, sliderData1, sliderData2, dateRange2, "COMPARE", rule);
            }
        }
        else {
            prepareActionTypeList(data, sliderData1, sliderData2, null, "COMPARE", rule);
        }
    };
    var buildFormDataAlert = function (data) {
        var form = {
            standardAlertSettingId: data.ruleSetting && data.ruleSetting.standardAlertSettingId > -1 ? data.ruleSetting.standardAlertSettingId : -1,
            scheduleSettings: data.settings && data.settings.scheduleSettings ? data.settings.scheduleSettings : null,
            objectType: data.settings && data.settings.reportDataSetting && data.settings.reportDataSetting.levelData ? data.settings.reportDataSetting.levelData : "",
            recipientSetting: data.settings && data.settings.recipientSetting ? data.settings.recipientSetting : null,
            sendingSettings: data.settings && data.settings.sendingSettings ? data.settings.sendingSettings : null,
            parentFilters: data.settings && data.settings.reportDataSetting && data.settings.reportDataSetting.parentFilters ? JSON.parse(data.settings.reportDataSetting.parentFilters) : "",
            ruleSetting: data.ruleSetting,
            ruleDescription: data.ruleDescription,
            enableSettingRule: data.settings && data.settings.reportDataSetting ? true : false
        };
        setEnableRuleSetting(form.enableSettingRule);
        var dynamicDuration = data.settings && data.settings.reportDataSetting && data.settings.reportDataSetting.datasourceCompare ? data.settings.reportDataSetting.datasourceCompare : {
            "customDurationTypeRange": "BEFORE_YESTERDAY",
        };
        var dynamicDurationChecking = data.settings && data.settings.reportDataSetting && data.settings.reportDataSetting.datasourceChecking ? data.settings.reportDataSetting.datasourceChecking : {
            "customDurationTypeRange": "YESTERDAY",
        };
        if (dynamicDuration) {
            form.customDurationTypeRange = dynamicDuration.customDurationTypeRange ? dynamicDuration.customDurationTypeRange : "BEFORE_YESTERDAY";
            form.customDurationSlideLength = dynamicDuration.customDurationSlideLength ? dynamicDuration.customDurationSlideLength : "7d";
            form.customDurationNumOfDays = dynamicDuration.customDurationNumOfDays ? dynamicDuration.customDurationNumOfDays : "";
            form.customDurationDistanceToEnd = dynamicDuration.customDurationDistanceToEnd ? dynamicDuration.customDurationDistanceToEnd : "";
            if (dynamicDuration.customDurationTypeRange == "CUSTOM_PERIOD") {
                form.customDurationFromDate = dynamicDuration.customDurationFromDate ? dynamicDuration.customDurationFromDate : "";
                form.customDurationToDate = dynamicDuration.customDurationToDate ? dynamicDuration.customDurationToDate : "";
            }
        }
        if (dynamicDurationChecking) {
            form.checkingDurationTypeRange = dynamicDurationChecking.customDurationTypeRange ? dynamicDurationChecking.customDurationTypeRange : "YESTERDAY";
            form.checkingDurationSlideLength = dynamicDurationChecking.customDurationSlideLength ? dynamicDurationChecking.customDurationSlideLength : "7d";
            form.checkingDurationNumOfDays = dynamicDurationChecking.customDurationNumOfDays ? dynamicDurationChecking.customDurationNumOfDays : "";
            form.checkingDurationDistanceToEnd = dynamicDurationChecking.customDurationDistanceToEnd ? dynamicDurationChecking.customDurationDistanceToEnd : "";
            if (dynamicDurationChecking.customDurationTypeRange == "CUSTOM_PERIOD") {
                form.checkingDurationFromDate = dynamicDurationChecking.customDurationFromDate ? dynamicDurationChecking.customDurationFromDate : "";
                form.checkingDurationToDate = dynamicDurationChecking.customDurationToDate ? dynamicDurationChecking.customDurationToDate : "";
            }
        }
        form.dataLevel = "";
        if (form.objectType) {
            var foundDataLevel = alertDataLevelOptions.find(function (dataLevelOption) { return dataLevelOption.value == form.objectType; });
            if (foundDataLevel && foundDataLevel.label) {
                form.dataLevel = foundDataLevel.label;
            }
        }
        form.p1Duration = "";
        form.p2Duration = "";
        if (form.checkingDurationTypeRange == "YESTERDAY") {
            form.p1Duration += "Yesterday";
        }
        else {
            if (form.checkingDurationTypeRange == "CUSTOM_PERIOD") {
                var minValueDate = moment(form.checkingDurationFromDate, "YYYYMMDD").format("YYYY/MM/DD");
                var maxValueDate = moment(form.checkingDurationToDate, "YYYYMMDD").format("YYYY/MM/DD");
                if (minValueDate) {
                    form.p1Duration += "" + minValueDate;
                }
                if (maxValueDate) {
                    form.p1Duration += " -> " + maxValueDate;
                }
            }
            else {
                var durationObj = buildDateString(form.checkingDurationTypeRange, true);
                if (durationObj) {
                    var startDate = durationObj.startDate ? durationObj.startDate : "";
                    var endDate = durationObj.endDate ? durationObj.endDate : "";
                    form.p1Duration = "" + startDate + " -> " + endDate;
                }
            }
        }
        if (form.customDurationTypeRange == "BEFORE_YESTERDAY") {
            form.p2Duration += "Before Yesterday";
        }
        else {
            if (form.customDurationTypeRange == "CUSTOM_PERIOD") {
                var minValueDate2 = moment(form.customDurationFromDate, "YYYYMMDD").format("YYYY/MM/DD");
                var maxValueDate2 = moment(form.customDurationToDate, "YYYYMMDD").format("YYYY/MM/DD");
                if (minValueDate2) {
                    form.p2Duration += "" + minValueDate2;
                }
                if (maxValueDate2) {
                    form.p2Duration += " -> " + maxValueDate2;
                }
            }
            else {
                var durationObj2 = buildDateString(form.customDurationTypeRange, true);
                if (durationObj2) {
                    var startDate2 = durationObj2.startDate ? durationObj2.startDate : "";
                    var endDate2 = durationObj2.endDate ? durationObj2.endDate : "";
                    form.p2Duration = "" + startDate2 + " -> " + endDate2;
                }
            }
        }
        return form;
    };
    var onBuildCurrentRule = function (detailData) {
        if (detailData && detailData.ruleSetting) {
            var data = buildFormDataAlert(detailData);
            setDataAlert(data);
            buildPeriodData(data);
        }
    };
    var onBuildTableAlertDetail = function (detailData) {
        if (detailData && detailData.header && detailData.header.length) {
            var columns_1 = detailData.header.map(function (header, index) {
                return {
                    id: header && header.key ? header.key : index,
                    label: header && header.displayName ? header.displayName : ""
                };
            });
            columns_1 = _.uniqBy(columns_1, function (column) {
                return column.id;
            });
            setRowItems(detailData.passedRows ? detailData.passedRows : []);
            setColumns(columns_1);
        }
    };
    var handleChangePage = function (event, newPage) {
        setPage(newPage);
    };
    var handleChangeRowsPerPage = function (event) {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    var formatValueMetric = function (metric) {
        if (metric) {
            return formatValueByMetric(metric.value, metric.category, metric.dataType, metric.decimalPrecision);
        }
        return "";
    };
    return (React.createElement(MainLayout, null,
        React.createElement("div", { className: "alert-details-page" },
            React.createElement("div", { className: "back-group" },
                React.createElement("a", { href: "#/dashboard" }, t('widget_details.back_to_dashboard'))),
            React.createElement(Paper, { className: "paper-form-card", elevation: 0, square: true },
                React.createElement("div", { className: "paper-form-header-card" },
                    React.createElement("h3", null,
                        t('alert.title'),
                        " ",
                        itemAlert && itemAlert.data ? "#" + itemAlert.data.id : "",
                        " ")),
                React.createElement("div", { className: "paper-form-body-card" },
                    React.createElement("div", { className: "form-group" },
                        React.createElement(Grid, { container: true, direction: "row", spacing: 2 },
                            React.createElement(Grid, { item: true, xs: 2, className: "form-group-label label-current-rule" },
                                React.createElement("label", null, t('alert.data_level'))),
                            React.createElement(Grid, { item: true, xs: 6 }, dataAlert && dataAlert.dataLevel ? React.createElement("span", null, dataAlert.dataLevel) : null))),
                    React.createElement("div", { className: "form-group" },
                        React.createElement(Grid, { container: true, direction: "row", spacing: 2 },
                            React.createElement(Grid, { item: true, xs: 2, className: "form-group-label label-current-rule" },
                                React.createElement("label", null, "P1 Duration")),
                            React.createElement(Grid, { item: true, xs: 6 }, dataAlert && dataAlert.p1Duration ? React.createElement("span", null, dataAlert.p1Duration) : null))),
                    React.createElement("div", { className: "form-group" },
                        React.createElement(Grid, { container: true, direction: "row", spacing: 2 },
                            React.createElement(Grid, { item: true, xs: 2, className: "form-group-label label-current-rule" },
                                React.createElement("label", null, "P2 Duration")),
                            React.createElement(Grid, { item: true, xs: 6 }, dataAlert && dataAlert.p2Duration ? React.createElement("span", null, dataAlert.p2Duration) : null))),
                    React.createElement("div", { className: "form-group" },
                        React.createElement(Grid, { container: true, direction: "row", spacing: 2 },
                            React.createElement(Grid, { item: true, xs: 2, className: "form-group-label label-current-rule" },
                                React.createElement("label", null, t('alert.current_rule'))),
                            isEnableRuleSetting ? React.createElement(Grid, { item: true, xs: 6, className: 'rule-alert-cart-content' },
                                currentRule ? React.createElement("span", null,
                                    React.createElement("strong", null, "Send Alert If")) : null,
                                React.createElement("div", { className: "rule-render", dangerouslySetInnerHTML: { __html: currentRule ? currentRule : "" } })) : React.createElement(Grid, { item: true, xs: 8 },
                                React.createElement("span", null, currentRule ? currentRule : "")))),
                    React.createElement("div", { className: "form-group" },
                        React.createElement(Grid, { container: true, direction: "row", justify: "center", spacing: 2 },
                            React.createElement(Grid, { item: true, xs: 10 },
                                React.createElement(TableContainer, { component: Paper },
                                    React.createElement(Table, { className: "table table-alert-detail", stickyHeader: true, "aria-label": "sticky table" },
                                        React.createElement(TableHead, null,
                                            React.createElement(TableRow, null, columns.map(function (column, index) { return (React.createElement(TableCell, { key: column.id, align: column.align, className: "header-table-alert-detail" }, column.label)); }))),
                                        React.createElement(TableBody, null, rowItems && rowItems.length ? rowItems.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (row) {
                                            return (React.createElement(TableRow, { hover: true, role: "checkbox", tabIndex: -1, key: row.code }, columns.map(function (column) {
                                                var value = row[column.id] ? formatValueMetric(row[column.id]) : "";
                                                var valueTrending = row[column.id] && row[column.id]["dailyTrendingValue"] ? row[column.id]["dailyTrendingValue"] : "";
                                                var styleFormat = row[column.id] && row[column.id].displayFormat ? row[column.id].displayFormat : null;
                                                var style = {
                                                    color: styleFormat ? styleFormat.color : ""
                                                };
                                                return (React.createElement(TableCell, { key: column.id, align: row[column.id] && row[column.id].textAlignment ? row[column.id].textAlignment : "center", style: style },
                                                    value,
                                                    React.createElement("p", null, valueTrending)));
                                            })));
                                        }) : React.createElement("div", { className: "title-not-found" }, t('common.not_found_data'))),
                                        rowItems && rowItems.length ? React.createElement(TableFooter, null,
                                            React.createElement(TableRow, null,
                                                React.createElement(TablePagination, { rowsPerPageOptions: [10, 30, 50, 100], count: rowItems.length, rowsPerPage: rowsPerPage, page: page, onPageChange: handleChangePage, onChangeRowsPerPage: handleChangeRowsPerPage }))) : null))))))))));
};
function mapStateToProps(state) {
    return {
        mediaList: mediaData(state),
        publisherData: publisherData(state)
    };
}
export default connect(mapStateToProps)(AlertCardDetailsPage);
